import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../utils/cn';
function SearchIcon() {
    return (_jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [_jsx("circle", { cx: "11", cy: "11", r: "7" }), _jsx("path", { d: "m20 20-3.5-3.5" })] }));
}
/**
 * Mittiger Such-/Command-Palette-Trigger fuer den `search`-Slot von
 * `<AppShell>` (Optik: `.sec-search-trigger`). Text und Shortcut-Hinweis sind
 * ueberschreibbar.
 */
export function SearchTrigger({ onOpen, placeholder = 'Suchen oder Befehl…', shortcutHint = 'Ctrl K', className, style, }) {
    return (_jsxs("button", { type: "button", onClick: onOpen, "aria-haspopup": "dialog", className: cn('sec-search-trigger', className), style: style, children: [_jsx(SearchIcon, {}), _jsx("span", { className: "sec-search-trigger__label", children: placeholder }), _jsx("kbd", { className: "sec-kbd", children: shortcutHint })] }));
}
